module.exports = __webpack_public_path__ + "static/media/card-vps-n8n-mobile-es.5b82588d.png";